import React, { useState, useEffect, useCallback, useContext } from "react";
import { styled } from '@mui/material/styles';

import {navigate} from "gatsby";

import { Grid, Box, Typography } from "@mui/material";
import { PlayArrow as PlayArrowIcon, Clear as ClearIcon } from '@mui/icons-material';

import { getEntityUrl } from "../util";

import { GlobalContext } from "../context/GlobalContext";
import { findByNumCode } from "../repository/EntityRepository";


const StyledBox = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    fontWeight:"700",
    "&:active": { backgroundColor: "#999" },
    cursor: "pointer",
}));

const defaultProps = {
    borderColor: "#ddd",
    m: 1,
    border: '1px solid #979797',
    style: { width: "5rem", height: "5rem" },
    fontWeight: '700'
};

const EntityKeypad = ({ entity, pageContext, config }) => {
    const { defaultLocale } = pageContext;
    const { entityRepository } = useContext(GlobalContext);

    const getEntityByNumCode = (numCode) => {
        if(config && config.numCodeGlobal) {
            const locale = entity.locale || defaultLocale;
            return entityRepository.findByNumCode(numCode, locale)
        } else {
            return findByNumCode(entity.strapiChildren, numCode)
        }
    }

    let buttons = [...Array(10).keys()];
    buttons.push('clr')
    buttons.push(buttons.shift());
    buttons.push('play');

    const [keyEntered, setKeyEntered] = useState(' ');
    const [foundEntity, setFoundEntity] = useState(undefined);

    const buttonClicked = useCallback((key) => {
        switch (key) {
            case 'clr':
                setKeyEntered('');
                setFoundEntity(undefined);
                break;
            case 'play':
                if(foundEntity) {
                    navigate(getEntityUrl({ entity: foundEntity, defaultLocale }));
                }
                break;
            default:
                setKeyEntered(keyEntered + key);
        }
    }, [keyEntered, foundEntity]);

    useEffect(() => {
        const checkEntry = () => {
            if (keyEntered !== undefined) {
                const entityByNumCode = getEntityByNumCode(keyEntered);
                if (entityByNumCode) {
                    setFoundEntity(entityByNumCode);
                } else {
                    setFoundEntity(undefined);
                }
            }
        };

        let timer;
        if (keyEntered.length >= 1) {//TODO - hardcoded 3
            timer = setTimeout(checkEntry, 200);
        }
        return () => {
            if (timer) { clearTimeout(timer); timer = null; }
        };
    }, [keyEntered, setFoundEntity]);

    return (
        <div align="center" className="keypad">
            <Grid container style={{ maxWidth: 450, }} spacing={1} justifyContent="center" height="90vh">
                <Grid item xs={12} align="center">
                    <Box {...defaultProps} m={0} style={{ height: '7rem' }} bgcolor="transparent" display="flex" alignItems="center" border="none" justifyContent="center">
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant="h4" fontSize="3rem">{keyEntered}</Typography>
                            </Grid>
                            <Grid item xs={12} style={{ minHeight: '50px', padding: '0 10px' }}>
                                <Typography variant="caption" lineHeight="1" fontSize="1.1rem">{foundEntity !== undefined && foundEntity.title}</Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                {buttons.map((item) => {
                    //item = ++item;
                    return (
                        <Grid key={item} item xs={4} align="center">
                            <StyledBox onClick={() => buttonClicked(item)} borderRadius="50%" lineHeight="0"  {...defaultProps} >
                                <KeypadButton {...{ playEnabled: foundEntity !== undefined, item }} />
                            </StyledBox>
                        </Grid>
                    );
                })}
            </Grid>
        </div>
    );
};

const KeypadButton = ({ item, playEnabled }) => {
    //const theme = useTheme();
    switch (item) {
        case 'clr':
            return <h4><ClearIcon color="error" sx={theme => ({ fontSize: theme.typography.h4.fontSize })} /></h4>;
        case 'play':
            return <h4><PlayArrowIcon disabled={!playEnabled} sx={theme => ({ color: playEnabled ? 'green' : 'lightgray', fontSize: theme.typography.h4.fontSize /*TODO - should be action color form theme */ })} /></h4>;
        default:
            return <Typography component="h4" variant="h4">{item}</Typography>;//TODO - make button?
    }
};

export default EntityKeypad;
